export default __webpack_public_path__ + "static/media/whitelabel-favicon.41b63c3d.svg";